import React from 'react';
import { Route, Navigate } from 'react-router-dom';

import Dashboard from 'Feature/dashboard/Dashboard';

import SalesDashbaord from 'Feature/dashboard/salesdashbaord';

import Grid from 'Feature/uiinterface/grid';
import Images from 'Feature/uiinterface/images';
import Lightboxes from 'Feature/uiinterface/lightbox';
import Media from 'Feature/uiinterface/media';
import Modals from 'Feature/uiinterface/modals';
import Offcanvas from 'Feature/uiinterface/offcanvas';
import Pagination from 'Feature/uiinterface/pagination';

import Alert from 'Feature/uiinterface/alert';
import Accordion from 'Feature/uiinterface/accordion';
import Avatar from 'Feature/uiinterface/avatar';
import Badges from 'Feature/uiinterface/badges';
import Borders from 'Feature/uiinterface/borders';
import Buttons from 'Feature/uiinterface/buttons';
import ButtonsGroup from 'Feature/uiinterface/buttonsgroup';
import Popovers from 'Feature/uiinterface/popover';

import Breadcrumb from 'Feature/uiinterface/breadcrumb';
import Cards from 'Feature/uiinterface/cards';
import Dropdowns from 'Feature/uiinterface/dropdowns';
import Colors from 'Feature/uiinterface/colors';
import Carousel from 'Feature/uiinterface/carousel';
import Spinner from 'Feature/uiinterface/spinner';
import NavTabs from 'Feature/uiinterface/navtabs';
import Toasts from 'Feature/uiinterface/toasts';
import Typography from 'Feature/uiinterface/typography';
import Video from 'Feature/uiinterface/video';
import Tooltips from 'Feature/uiinterface/tooltips';
import DragDrop from 'Feature/uiinterface/advancedui/dragdrop';
import SweetAlert from 'Feature/uiinterface/sweetalert';
import Progress from 'Feature/uiinterface/progress';
import Placeholder from 'Feature/uiinterface/placeholder';
import Rating from 'Feature/uiinterface/advancedui/rating';
import TextEditor from 'Feature/uiinterface/advancedui/texteditor';
import Counter from 'Feature/uiinterface/advancedui/counter';
import Uiscrollbar from 'Feature/uiinterface/advancedui/uiscrollbar';
import Stickynote from 'Feature/uiinterface/advancedui/stickynote';
import Timeline from 'Feature/uiinterface/advancedui/timeline';
import Apexchart from 'Feature/uiinterface/charts/apexcharts';
import ChartJs from 'Feature/uiinterface/charts/chartjs';
import RangeSlides from 'Feature/uiinterface/rangeslider';
import FontawesomeIcons from 'Feature/uiinterface/icons/fontawesome';
import FeatherIcons from 'Feature/uiinterface/icons/feathericon';
import IonicIcons from 'Feature/uiinterface/icons/ionicicons';
import MaterialIcons from 'Feature/uiinterface/icons/materialicon';
import PE7Icons from 'Feature/uiinterface/icons/pe7icons';
import SimplelineIcons from 'Feature/uiinterface/icons/simplelineicon';
import ThemifyIcons from 'Feature/uiinterface/icons/themify';
import WeatherIcons from 'Feature/uiinterface/icons/weathericons';
import TypiconIcons from 'Feature/uiinterface/icons/typicons';
import FlagIcons from 'Feature/uiinterface/icons/flagicons';

import ClipBoard from 'Feature/uiinterface/advancedui/clipboard';
import TablesBasic from 'Feature/uiinterface/table/tables-basic';
import DataTables from 'Feature/uiinterface/table/data-tables';
import FormBasicInputs from 'Feature/uiinterface/forms/formelements/basic-inputs';
import CheckboxRadios from 'Feature/uiinterface/forms/formelements/checkbox-radios';
import InputGroup from 'Feature/uiinterface/forms/formelements/input-group';
import GridGutters from 'Feature/uiinterface/forms/formelements/grid-gutters';
import FormSelect from 'Feature/uiinterface/forms/formelements/form-select';
import FileUpload from 'Feature/uiinterface/forms/formelements/fileupload';
import FormMask from 'Feature/uiinterface/forms/formelements/form-mask';
import FormHorizontal from 'Feature/uiinterface/forms/formelements/layouts/form-horizontal';
import FormVertical from 'Feature/uiinterface/forms/formelements/layouts/form-vertical';
import FloatingLabel from 'Feature/uiinterface/forms/formelements/layouts/floating-label';
import FormValidation from 'Feature/uiinterface/forms/formelements/layouts/form-validation';
import FormSelect2 from 'Feature/uiinterface/forms/formelements/layouts/form-select2';
import Ribbon from 'Feature/uiinterface/advancedui/ribbon';
 
 
import FormWizard from 'Feature/uiinterface/forms/formelements/form-wizard';

// import Videocall from 'Feature/application/videocall';
// import Audiocall from 'Feature/application/audiocall';
// import Email from 'Feature/application/email';
// import Callhistory from 'Feature/application/callhistory';
// import ToDo from 'Feature/application/todo';

import InspectionPlanView from 'Feature/inspectionplan/inspectionplan-view';
import InventoryView from 'Feature/inventory/inventory-view';
import InventoryScanningView from 'Feature/inventory-scanning/inventory-scanning-view';
import ShipmentView from 'Feature/shipment/shipment-view';
import ProductionView from 'Feature/production/production-view';
import CustomerMastersView from 'Feature/customermasters/customermasters-view';
import CarrierMastersView from 'Feature/carriermasters/carriermasters-view';
import LocationMastersView from 'Feature/locationmasters/locationmasters-view';
import MachineView from 'Feature/machine/machine-view';
import PartMastersView from 'Feature/partmasters/partmasters-view';
import POView from 'Feature/pomasters/pomasters-view';
import MappingsView from 'Feature/mappings/mappings-view'; 
import Appearance from 'Feature/settings/websitesettings/appearance';
import SocialAuthentication from 'Feature/settings/websitesettings/socialauthentication';
import LanguageSettings from 'Feature/settings/websitesettings/languagesettings';
import InvoiceSettings from 'Feature/settings/appsetting/invoicesettings';
import PrinterSettings from 'Feature/settings/appsetting/printersettings';
import PosSettings from 'Feature/settings/websitesettings/possettings';
import CustomFields from 'Feature/settings/websitesettings/customfields';
import EmailSettings from 'Feature/settings/systemsettings/emailsettings';
import SmsGateway from 'Feature/settings/systemsettings/smsgateway';
import OtpSettings from 'Feature/settings/systemsettings/otpsettings';
import GdprSettings from 'Feature/settings/systemsettings/gdprsettings';
import PaymentGateway from 'Feature/settings/financialsettings/paymentgateway';
import BankSetting from 'Feature/settings/financialsettings/banksetting';
import Customers from 'Feature/people/customers';
import Suppliers from 'Feature/people/suppliers';
import StoreList from '../core/modals/peoples/storelist';

import SalesReport from 'Feature/reports/salesreport';
import PurchaseReport from 'Feature/reports/purchasereport';
import InventoryReport from 'Feature/reports/inventoryreport';
import Invoicereport from 'Feature/reports/invoicereport';
import SupplierReport from 'Feature/reports/supplierreport';
import CustomerReport from 'Feature/reports/customerreport';
import ExpenseReport from 'Feature/reports/expensereport';
import IncomeReport from 'Feature/reports/incomereport';
import TaxReport from 'Feature/reports/taxreport';
import ProfitLoss from 'Feature/reports/profitloss';
import GeneralSettings from 'Feature/settings/generalsettings/generalsettings';
import SecuritySettings from 'Feature/settings/generalsettings/securitysettings';
import Notification from 'Feature/settings/generalsettings/notification';
import ConnectedApps from 'Feature/settings/generalsettings/connectedapps';
import SystemSettings from 'Feature/settings/websitesettings/systemsettings';
import CompanySettings from 'Feature/settings/websitesettings/companysettings';
import LocalizationSettings from 'Feature/settings/websitesettings/localizationsettings';
import Prefixes from 'Feature/settings/websitesettings/prefixes';
import Preference from 'Feature/settings/websitesettings/preference';
import BanIpaddress from 'Feature/settings/othersettings/ban-ipaddress';
import StorageSettings from 'Feature/settings/othersettings/storagesettings';

import Notes from 'Feature/application/notes';
import FileManager from 'Feature/application/filemanager';
import Profile from 'Feature/pages/profile';
import Signin from 'Feature/pages/login/signin';
import SigninTwo from 'Feature/pages/login/signinTwo';
import SigninThree from 'Feature/pages/login/signinThree';
import RegisterTwo from 'Feature/pages/register/registerTwo';
import Register from 'Feature/pages/register/register';
import RegisterThree from 'Feature/pages/register/registerThree';
import Forgotpassword from 'Feature/pages/forgotpassword/forgotpassword';
import ForgotpasswordTwo from 'Feature/pages/forgotpassword/forgotpasswordTwo';
import ForgotpasswordThree from 'Feature/pages/forgotpassword/forgotpasswordThree';
import Resetpassword from 'Feature/pages/resetpassword/resetpassword';
import ResetpasswordTwo from 'Feature/pages/resetpassword/resetpasswordTwo';
import ResetpasswordThree from 'Feature/pages/resetpassword/resetpasswordThree';
import EmailVerification from 'Feature/pages/emailverification/emailverification';
import EmailverificationTwo from 'Feature/pages/emailverification/emailverificationTwo';
import EmailverificationThree from 'Feature/pages/emailverification/emailverificationThree';
import Twostepverification from 'Feature/pages/twostepverification/twostepverification';
import TwostepverificationTwo from 'Feature/pages/twostepverification/twostepverificationTwo';
import TwostepverificationThree from 'Feature/pages/twostepverification/twostepverificationThree';
import Lockscreen from 'Feature/pages/lockscreen';
import Error404 from 'Feature/pages/errorpages/error404';
import Error500 from 'Feature/pages/errorpages/error500';
import Blankpage from 'Feature/pages/blankpage';
import Comingsoon from 'Feature/pages/comingsoon';
import Undermaintainence from 'Feature/pages/undermaintainence';
import Users from 'Feature/usermanagement/users';
import RolesPermissions from 'Feature/usermanagement/rolespermissions';
import Permissions from 'Feature/usermanagement/permissions';
import DeleteAccount from 'Feature/usermanagement/deleteaccount';

import TaxRates from 'Feature/settings/financialsettings/taxrates';
import CurrencySettings from 'Feature/settings/financialsettings/currencysettings';
import WareHouses from '../core/modals/peoples/warehouses';

import { all_routes } from './all_routes';
import BankSettingGrid from 'Feature/settings/financialsettings/banksettinggrid';
import QualityApprovalView from 'Feature/qualityapproval/qualityapproval-view';
import PlanView from 'Feature/plan/plan-view';
import InspectionResultsView from 'Feature/inspectionresults/inspectionresults-view';
import UnderConstruction from 'Core/components/underconstruction/under-construction';
import UserRegister from '../feature-module/usermanagement/user-register';
import MoldMaintenanceView from '../feature-module/mold-maintenance/mold-maintenance-view';
import MoldReceivingView from '../feature-module/mold-receiving/mold-receiving-view';
import MoldReleaseView from '../feature-module/mold-release/mold-release-view';
import FutureActionsView from '../feature-module/future-actions/future-actions-view';
import CellView from '../feature-module/cell/cell-view';
import WorkTicketView from '../feature-module/workticket/work-ticket-view';
import VendorView from 'Feature/vendormasters/vendormasters-view';
import QualityAlertView from '../feature-module/quality-alert-pages/quality-alert-view';
import AuxiliaryEquipmentView from '../feature-module/auxiliary-equipment/auxiliary-equipment-view';
import ForkliftView from '../feature-module/forklift/forklift-view';
import WaterTowersView from '../feature-module/water-towers/water-towers-view';
import AirCompressorsView from '../feature-module/air-compressors/air-compressors-view';
import PlantView from '../feature-module/plant/plant-view';
import RobotsView from '../feature-module/robots/robots-view';
import OverheadCraneView from '../feature-module/overhead-crane/overhead-crane-view';
import PlannerV2View from '../feature-module/planner-v2/planner-v2-view';
import PlanningWorkspaceView from '../feature-module/planning-workspace/planning-workspace-view';
import AuthCallback from '../auth/AuthCallback';
import PlannerDashboardView from '../feature-module/planner dashboard/planner-dashboard-view';
import ChangeRequestView from '../feature-module/change-request/change-request-view';
import CipRegisterView from '../feature-module/cip-register/cip-register-view';
import NotificationsView from '../feature-module/notifications/notifications-view';
import NotificationEventsAdminView from '../feature-module/notifications/notification-events-admin';
import {
  AccessRolesPage,
  AccessMatrixPage,
  AccessCatalogPage,
  AccessPreviewPage,
  AccessAuditPage,
} from '../feature-module/access-control/access-control-pages';
import NoAccess from '../feature-module/access-control/no-access';

const routes = all_routes;

export const publicRoutes = [
  {
    id: 1,
    path: routes.dashboard,
    name: 'home',
    element: <Dashboard />,
    route: Route,
  },

  {
    id: 4,
    path: routes.salesdashboard,
    name: 'salesdashboard',
    element: <SalesDashbaord />,
    route: Route,
  },

  {
    id: 10,
    path: routes.alerts,
    name: 'alert',
    element: <Alert />,
    route: Route,
  },
  {
    id: 11,
    path: routes.grid,
    name: 'grid',
    element: <Grid />,
    route: Route,
  },

  {
    id: 12,
    path: routes.accordion,
    name: 'accordion',
    element: <Accordion />,
    route: Route,
  },
  {
    id: 13,
    path: routes.avatar,
    name: 'avatar',
    element: <Avatar />,
    route: Route,
  },
  {
    id: 14,
    path: routes.images,
    name: 'images',
    element: <Images />,
    route: Route,
  },

  {
    id: 15,
    path: routes.badges,
    name: 'badges',
    element: <Badges />,
    route: Route,
  },
  {
    id: 16,
    path: routes.lightbox,
    name: 'lightbox',
    element: <Lightboxes />,
    route: Route,
  },

  {
    id: 17,
    path: routes.borders,
    name: 'borders',
    element: <Borders />,
    route: Route,
  },
  {
    id: 18,
    path: routes.media,
    name: 'lightbox',
    element: <Media />,
    route: Route,
  },
  {
    id: 19,
    path: routes.buttons,
    name: 'borders',
    element: <Buttons />,
    route: Route,
  },
  {
    id: 20,
    path: routes.modals,
    name: 'modals',
    element: <Modals />,
    route: Route,
  },
  {
    id: 21,
    path: routes.offcanvas,
    name: 'offcanvas',
    element: <Offcanvas />,
    route: Route,
  },
  {
    id: 22,
    path: routes.pagination,
    name: 'offcanvas',
    element: <Pagination />,
    route: Route,
  },
  {
    id: 23,
    path: routes.buttonsgroup,
    name: 'buttonsgroup',
    element: <ButtonsGroup />,
    route: Route,
  },
  {
    id: 24,
    path: routes.popover,
    name: 'buttonsgroup',
    element: <Popovers />,
    route: Route,
  },
  {
    id: 25,
    path: routes.breadcrumb,
    name: 'breadcrumb',
    element: <Breadcrumb />,
    route: Route,
  },
  {
    id: 26,
    path: routes.cards,
    name: 'cards',
    element: <Cards />,
    route: Route,
  },
  {
    id: 27,
    path: routes.dropdowns,
    name: 'dropdowns',
    element: <Dropdowns />,
    route: Route,
  },
  {
    id: 27,
    path: routes.colors,
    name: 'colors',
    element: <Colors />,
    route: Route,
  },
  {
    id: 28,
    path: routes.carousel,
    name: 'carousel',
    element: <Carousel />,
    route: Route,
  },
  {
    id: 29,
    path: routes.spinner,
    name: 'spinner',
    element: <Spinner />,
    route: Route,
  },
  {
    id: 30,
    path: routes.carousel,
    name: 'carousel',
    element: <Carousel />,
    route: Route,
  },
  {
    id: 31,
    path: routes.navtabs,
    name: 'navtabs',
    element: <NavTabs />,
    route: Route,
  },
  {
    id: 32,
    path: routes.toasts,
    name: 'toasts',
    element: <Toasts />,
    route: Route,
  },
  {
    id: 33,
    path: routes.typography,
    name: 'typography',
    element: <Typography />,
    route: Route,
  },
  {
    id: 34,
    path: routes.video,
    name: 'video',
    element: <Video />,
    route: Route,
  },
  {
    id: 35,
    path: routes.tooltip,
    name: 'tooltip',
    element: <Tooltips />,
    route: Route,
  },
  {
    id: 36,
    path: routes.draganddrop,
    name: 'draganddrop',
    element: <DragDrop />,
    route: Route,
  },
  {
    id: 37,
    path: routes.sweetalerts,
    name: 'sweetalerts',
    element: <SweetAlert />,
    route: Route,
  },
  {
    id: 38,
    path: routes.progress,
    name: 'progress',
    element: <Progress />,
    route: Route,
  },

  {
    id: 39,
    path: routes.placeholder,
    name: 'placeholder',
    element: <Placeholder />,
    route: Route,
  },

  {
    id: 40,
    path: routes.rating,
    name: 'rating',
    element: <Rating />,
  },

  {
    id: 41,
    path: routes.texteditor,
    name: 'text-editor',
    element: <TextEditor />,
    route: Route,
  },

  {
    id: 42,
    path: routes.counter,
    name: 'counter',
    element: <Counter />,
    route: Route,
  },

  {
    id: 43,
    path: routes.scrollbar,
    name: 'scrollbar',
    element: <Uiscrollbar />,
    route: Route,
  },
  {
    id: 43,
    path: routes.clipboard,
    name: 'clipboard',
    element: <ClipBoard />,
    route: Route,
  },
  {
    id: 44,
    path: routes.stickynote,
    name: 'stickynote',
    element: <Stickynote />,
    route: Route,
  },
  {
    id: 44,
    path: routes.tablebasic,
    name: 'tablebasic',
    element: <TablesBasic />,
    route: Route,
  },
  {
    id: 45,
    path: routes.timeline,
    name: 'timeline',
    element: <Timeline />,
    route: Route,
  },
  {
    id: 45,
    path: routes.datatable,
    name: 'datatable',
    element: <DataTables />,
    route: Route,
  },
  {
    id: 46,
    path: routes.apexchart,
    name: 'apex-chart',
    element: <Apexchart />,
    route: Route,
  },

  {
    id: 46,
    path: routes.basicinput,
    name: 'formbasicinput',
    element: <FormBasicInputs />,
    route: Route,
  },
  {
    id: 47,
    path: routes.chartjs,
    name: 'chart-js',
    element: <ChartJs />,
    route: Route,
  },
  {
    id: 47,
    path: routes.checkboxradio,
    name: 'checkboxradio',
    element: <CheckboxRadios />,
    route: Route,
  },
  {
    id: 48,
    path: routes.rangeslider,
    name: 'range-slider',
    element: <RangeSlides />,
    route: Route,
  },
  {
    id: 49,
    path: routes.fontawesome,
    name: 'fontawesome',
    element: <FontawesomeIcons />,
    route: Route,
  },
  {
    id: 50,
    path: routes.feathericon,
    name: 'feathericon',
    element: <FeatherIcons />,
    route: Route,
  },
  {
    id: 51,
    path: routes.ionicicons,
    name: 'ionicicons',
    element: <IonicIcons />,
    route: Route,
  },
  {
    id: 52,
    path: routes.materialicons,
    name: 'materialicons',
    element: <MaterialIcons />,
    route: Route,
  },
  {
    id: 53,
    path: routes.pe7icons,
    name: 'pe7icons',
    element: <PE7Icons />,
    route: Route,
  },
  {
    id: 54,
    path: routes.simpleline,
    name: 'simpleline',
    element: <SimplelineIcons />,
    route: Route,
  },
  {
    id: 55,
    path: routes.themifyicons,
    name: 'themifyicon',
    element: <ThemifyIcons />,
    route: Route,
  },
  {
    id: 56,
    path: routes.iconweather,
    name: 'iconweather',
    element: <WeatherIcons />,
    route: Route,
  },
  {
    id: 57,
    path: routes.typicons,
    name: 'typicons',
    element: <TypiconIcons />,
    route: Route,
  },
  {
    id: 58,
    path: routes.flagicons,
    name: 'flagicons',
    element: <FlagIcons />,
    route: Route,
  },
  {
    id: 58,
    path: routes.inputgroup,
    name: 'inputgroup',
    element: <InputGroup />,
    route: Route,
  },
  {
    id: 59,
    path: routes.ribbon,
    name: 'ribbon',
    element: <Ribbon />,
    route: Route,
  },
   
  {
    id: 49,
    path: routes.gridgutters,
    name: 'gridgutters',
    element: <GridGutters />,
    route: Route,
  },
  {
    id: 50,
    path: routes.gridgutters,
    name: 'gridgutters',
    element: <GridGutters />,
    route: Route,
  },
  {
    id: 51,
    path: routes.formselect,
    name: 'formselect',
    element: <FormSelect />,
    route: Route,
  },
  {
    id: 52,
    path: routes.fileupload,
    name: 'fileupload',
    element: <FileUpload />,
    route: Route,
  },
  {
    id: 53,
    path: routes.formmask,
    name: 'formmask',
    element: <FormMask />,
    route: Route,
  },
  {
    id: 54,
    path: routes.formhorizontal,
    name: 'formhorizontal',
    element: <FormHorizontal />,
    route: Route,
  },
  {
    id: 54,
    path: routes.formvertical,
    name: 'formvertical',
    element: <FormVertical />,
    route: Route,
  },
  {
    id: 55,
    path: routes.floatinglabel,
    name: 'floatinglabel',
    element: <FloatingLabel />,
    route: Route,
  },
  {
    id: 56,
    path: routes.formvalidation,
    name: 'formvalidation',
    element: <FormValidation />,
    route: Route,
  },
  {
    id: 57,
    path: routes.select2,
    name: 'select2',
    element: <FormSelect2 />,
    route: Route,
  },
  {
    id: 58,
    path: routes.wizard,
    name: 'wizard',
    element: <FormWizard />,
    route: Route,
  },

  
  // {
  //   id: 63,
  //   path: routes.videocall,
  //   name: 'videocall',
  //   element: <Videocall />,
  //   route: Route,
  // },
  // {
  //   id: 64,
  //   path: routes.audiocall,
  //   name: 'audiocall',
  //   element: <Audiocall />,
  //   route: Route,
  // },
  // {
  //   id: 65,
  //   path: routes.email,
  //   name: 'email',
  //   element: <Email />,
  //   route: Route,
  // },
  // {
  //   id: 66,
  //   path: routes.callhistory,
  //   name: 'callhistory',
  //   element: <Callhistory />,
  //   route: Route,
  // },
  // {
  //   id: 67,
  //   path: routes.todo,
  //   name: 'todo',
  //   element: <ToDo />,
  //   route: Route,
  // },

  {
    id: 71,
    path: routes.appearance,
    name: 'appearance',
    element: <Appearance />,
    route: Route,
  },
  {
    id: 72,
    path: routes.socialauthendication,
    name: 'socialauthendication',
    element: <SocialAuthentication />,
    route: Route,
  },
  {
    id: 73,
    path: routes.languagesettings,
    name: 'languagesettings',
    element: <LanguageSettings />,
    route: Route,
  },
  {
    id: 74,
    path: routes.invoicesettings,
    name: 'invoicesettings',
    element: <InvoiceSettings />,
    route: Route,
  },
  {
    id: 75,
    path: routes.printersettings,
    name: 'printersettings',
    element: <PrinterSettings />,
    route: Route,
  },
  {
    id: 76,
    path: routes.possettings,
    name: 'possettings',
    element: <PosSettings />,
    route: Route,
  },
  {
    id: 77,
    path: routes.customfields,
    name: 'customfields',
    element: <CustomFields />,
    route: Route,
  },
  {
    id: 78,
    path: routes.emailsettings,
    name: 'emailsettings',
    element: <EmailSettings />,
    route: Route,
  },
  {
    id: 79,
    path: routes.smssettings,
    name: 'smssettings',
    element: <SmsGateway />,
    route: Route,
  },
  {
    id: 80,
    path: routes.otpsettings,
    name: 'otpsettings',
    element: <OtpSettings />,
    route: Route,
  },
  {
    id: 81,
    path: routes.gdbrsettings,
    name: 'gdbrsettings',
    element: <GdprSettings />,
    route: Route,
  },
  {
    id: 82,
    path: routes.paymentgateway,
    name: 'paymentgateway',
    element: <PaymentGateway />,
    route: Route,
  },
  {
    id: 83,
    path: routes.banksettingslist,
    name: 'banksettingslist',
    element: <BankSetting />,
    route: Route,
  },
  {
    id: 84,
    path: routes.customers,
    name: 'customers',
    element: <Customers />,
    route: Route,
  },
  {
    id: 85,
    path: routes.suppliers,
    name: 'suppliers',
    element: <Suppliers />,
    route: Route,
  },
  {
    id: 86,
    path: routes.storelist,
    name: 'storelist',
    element: <StoreList />,
    route: Route,
  },

  {
    id: 90,
    path: routes.salesreport,
    name: 'salesreport',
    element: <SalesReport />,
    route: Route,
  },
  {
    id: 91,
    path: routes.purchasereport,
    name: 'purchasereport',
    element: <PurchaseReport />,
    route: Route,
  },
  {
    id: 92,
    path: routes.inventoryreport,
    name: 'inventoryreport',
    element: <InventoryReport />,
    route: Route,
  },
  {
    id: 93,
    path: routes.invoicereport,
    name: 'invoicereport',
    element: <Invoicereport />,
    route: Route,
  },
  {
    id: 94,
    path: routes.supplierreport,
    name: 'supplierreport',
    element: <SupplierReport />,
    route: Route,
  },
  {
    id: 95,
    path: routes.customerreport,
    name: 'customerreport',
    element: <CustomerReport />,
    route: Route,
  },
  {
    id: 96,
    path: routes.expensereport,
    name: 'expensereport',
    element: <ExpenseReport />,
    route: Route,
  },
  {
    id: 97,
    path: routes.incomereport,
    name: 'incomereport',
    element: <IncomeReport />,
    route: Route,
  },
  {
    id: 98,
    path: routes.taxreport,
    name: 'taxreport',
    element: <TaxReport />,
    route: Route,
  },
  {
    id: 99,
    path: routes.profitloss,
    name: 'profitloss',
    element: <ProfitLoss />,
    route: Route,
  },
  {
    id: 89,
    path: routes.generalsettings,
    name: 'generalsettings',
    element: <GeneralSettings />,
    route: Route,
  },
  {
    id: 90,
    path: routes.securitysettings,
    name: 'securitysettings',
    element: <SecuritySettings />,
    route: Route,
  },
  {
    id: 91,
    path: routes.notification,
    name: 'notification',
    element: <Notification />,
    route: Route,
  },
  {
    id: 92,
    path: routes.connectedapps,
    name: 'connectedapps',
    element: <ConnectedApps />,
    route: Route,
  },
  {
    id: 93,
    path: routes.systemsettings,
    name: 'systemsettings',
    element: <SystemSettings />,
    route: Route,
  },
  {
    id: 94,
    path: routes.companysettings,
    name: 'companysettings',
    element: <CompanySettings />,
    route: Route,
  },
  {
    id: 94,
    path: routes.localizationsettings,
    name: 'localizationsettings',
    element: <LocalizationSettings />,
    route: Route,
  },
  {
    id: 95,
    path: routes.prefixes,
    name: 'prefixes',
    element: <Prefixes />,
    route: Route,
  },
  {
    id: 99,
    path: routes.preference,
    name: 'preference',
    element: <Preference />,
    route: Route,
  },
  {
    id: 99,
    path: routes.banipaddress,
    name: 'banipaddress',
    element: <BanIpaddress />,
    route: Route,
  },
  {
    id: 99,
    path: routes.storagesettings,
    name: 'storagesettings',
    element: <StorageSettings />,
    route: Route,
  },
  {
    id: 99,
    path: routes.taxrates,
    name: 'taxrates',
    element: <TaxRates />,
    route: Route,
  },
  {
    id: 99,
    path: routes.currencysettings,
    name: 'currencysettings',
    element: <CurrencySettings />,
    route: Route,
  },

  {
    id: 104,
    path: routes.notes,
    name: 'notes',
    element: <Notes />,
    route: Route,
  },
  {
    id: 105,
    path: routes.filemanager,
    name: 'filemanager',
    element: <FileManager />,
    route: Route,
  },
  {
    id: 106,
    path: routes.profile,
    name: 'profile',
    element: <Profile />,
    route: Route,
  },
  {
    id: 20,
    path: routes.blankpage,
    name: 'blankpage',
    element: <Blankpage />,
    route: Route,
  },
  {
    id: 104,
    path: routes.users,
    name: 'users',
    element: <Users />,
    route: Route,
  },
  {
    id: 105,
    path: routes.rolespermission,
    name: 'rolespermission',
    element: <RolesPermissions />,
    route: Route,
  },
  {
    id: 106,
    path: routes.permissions,
    name: 'permissions',
    element: <Permissions />,
    route: Route,
  },
  {
    id: 107,
    path: routes.deleteaccount,
    name: 'deleteaccount',
    element: <DeleteAccount />,
    route: Route,
  },

  {
    id: 114,
    path: routes.warehouses,
    name: 'warehouses',
    element: <WareHouses />,
    route: Route,
  },

  {
    id: 116,
    path: '*',
    name: 'NotFound',
    element: <Navigate to="/" />,
    route: Route,
  },
  {
    id: 117,
    path: '/',
    name: 'Root',
    element: <Navigate to="/signin" />,
    route: Route,
  },
  {
    id: 118,
    path: routes.banksettingsgrid,
    name: 'banksettingsgrid',
    element: <BankSettingGrid />,
    route: Route,
  },

  {
    id: 120,
    path: routes.inventoeytile,
    name: 'inventorytile',
    element: <InventoryView />,
    route: Route,
  },
  {
    id: 120.5,
    path: routes.inventoryscanning,
    name: 'inventoryscanning',
    element: <InventoryScanningView />,
    route: Route,
  },
  {
    id: 121,
    path: routes.shipmenttile,
    name: 'shipmenttile',
    element: <ShipmentView />,
    route: Route,
  },
  {
    id: 122,
    path: routes.inspectionplantile,
    name: 'inspectionplantile',
    element: <InspectionPlanView />,
    route: Route,
  },
  {
    id: 123,
    path: routes.qualityapproval,
    name: 'qualityapproval',
    element: <QualityApprovalView />,
    route: Route,
  },
  {
    id: 124,
    path: routes.inspectionresults,
    name: 'inspectionresults',
    element: <InspectionResultsView />,
    route: Route,
  },
  {
    id: 125,
    path: routes.shipments,
    name: 'shipments',
    element: <ShipmentView />,
    route: Route,
  },
  {
    id: 126,
    path: routes.production,
    name: 'production',
    element: <ProductionView />,
    route: Route,
  },
  {
    id: 127,
    path: routes.plan,
    name: 'plan',
    element: <PlanView />,
  },
  {
    id: 128,
    path: routes.customermaster,
    name: 'customermaster',
    element: <CustomerMastersView />,
    route: Route,
  },
  {
    id: 128.5,
    path: routes.carriermaster,
    name: 'carriermaster',
    element: <CarrierMastersView />,
    route: Route,
  },
  {
    id: 129,
    path: routes.partmaster,
    name: 'partmaster',
    element: <PartMastersView />,
    route: Route,
  },
  {
    id: 130,
    path: routes.material,
    name: 'material',
    element: <UnderConstruction />,
    route: Route,
  },
  {
    id: 130,
    path: routes.locationmaster,
    name: 'locationmaster',
    element: <LocationMastersView />,
    route: Route,
  },
  {
    id: 131,
    path: routes.machine,
    name: 'machine',
    element: <MachineView />,
    route: Route,
  },
  {
    id: 132,
    path: routes.userregister,
    name: 'userregister',
    element: <UserRegister />,
    route: Route,
  },
  {
    id: 133,
    path: routes.moldreceiving,
    name: 'moldreceivingview',
    element: <MoldReceivingView />,
    route: Route,
  },
  {
    id: 134,
    path: routes.moldmaintenance,
    name: 'moldmaintenanceview',
    element: <MoldMaintenanceView />,
    route: Route,
  },
  {
    id: 135,
    path: routes.moldrelease,
    name: 'moldreleaseview',
    element: <MoldReleaseView />,
    route: Route,
  },
  {
    id: 136,
    path: routes.futureactions,
    name: 'futureactionsview',
    element: <FutureActionsView />,
    route: Route,
  },
  {
    id: 137,
    path: routes.cell,
    name: 'cellview',
    element: <CellView />,
    route: Route,
  },
  {
    id: 137,
    path: routes.workticket,
    name: 'workticketview',
    element: <WorkTicketView/>,
    route: Route,
  },
  {
    id: 138,
    path: routes.qualityalert,
    name: 'qualityalertpagesview',
    element: <QualityAlertView/>,
    route: Route,
  },
  {
    id: 140,
    path: routes.vendormaster,
    name: 'vendormaster',
    element: <VendorView />,
    route: Route,
  },
  {
    id: 141,
    path: routes.pos,
    name: 'pomaster',
    element: <POView />,
    route: Route,
  },
  {
    id: 142,
    path: routes.mappings,
    name: 'mappings',
    element: <MappingsView />,
    route: Route,
  },
  {
    id: 143,
    path: routes.auxiliaryequipment,
    name: 'auxiliaryequipmentview',
    element: <AuxiliaryEquipmentView />,
    route: Route,
  },
  {
    id: 144,
    path: routes.forklift,
    name: 'forkliftview',
    element: <ForkliftView />,
    route: Route,
  },
  {
    id: 145,
    path: routes.watertowers,
    name: 'watertowersview',
    element: <WaterTowersView />,
    route: Route,
  },
  {
    id: 146,
    path: routes.aircompressors,
    name: 'aircompressorsview',
    element: <AirCompressorsView />,
    route: Route,
  },
  {
    id: 147,
    path: routes.plant,
    name: 'plantview',
    element: <PlantView />,
    route: Route,
  },
  {
    id: 148,
    path: routes.robots,
    name: 'robotsview',
    element: <RobotsView />,
    route: Route,
  },
  {
    id: 149,
    path: routes.overheadcrane,
    name: 'overheadcraneview',
    element: <OverheadCraneView />,
    route: Route,
  },
    {
    id: 150,
    path: routes.plannerv2,
    name: 'plannerv2view',
    element: <PlannerV2View />,
    route: Route,
  },
  {
    id: 152,
    path: routes.planningworkspace,
    name: 'planningworkspaceview',
    element: <PlanningWorkspaceView />,
    route: Route,
  },
   {
    id: 151,
    path: routes.plannerdashboard,
    name: 'plannerdashboardview',
    element: <PlannerDashboardView />,
    route: Route,
  },
  {
    id: 152,
    path: routes.changerequest,
    name: 'changerequestview',
    element: <ChangeRequestView />,
    route: Route,
  },
  {
    id: 153,
    path: routes.cipregister,
    name: 'cipregisterview',
    element: <CipRegisterView />,
    route: Route,
  },
  {
    id: 154,
    path: routes.notifications,
    name: 'notificationsview',
    element: <NotificationsView />,
    route: Route,
  },
  {
    id: 155,
    path: routes.notificationEvents,
    name: 'notificationeventsadmin',
    element: <NotificationEventsAdminView />,
    route: Route,
  },
  // Access Control (RBAC) module — one submodule page per screen
  {
    id: 156,
    path: routes.accesscontrol,
    name: 'accesscontrol',
    element: <Navigate to={routes.accessroles} replace />,
    route: Route,
  },
  {
    id: 157,
    path: routes.accessroles,
    name: 'accessroles',
    element: <AccessRolesPage />,
    route: Route,
  },
  {
    id: 158,
    path: routes.accessmatrix,
    name: 'accessmatrix',
    element: <AccessMatrixPage />,
    route: Route,
  },
  {
    id: 159,
    path: routes.accesscatalog,
    name: 'accesscatalog',
    element: <AccessCatalogPage />,
    route: Route,
  },
  {
    id: 160,
    path: routes.accesspreview,
    name: 'accesspreview',
    element: <AccessPreviewPage />,
    route: Route,
  },
  {
    id: 161,
    path: routes.accessaudit,
    name: 'accessaudit',
    element: <AccessAuditPage />,
    route: Route,
  },
];
export const posRoutes = [
  {
    id: 1,
    path: '',
    name: 'pos',
    element: <POView />,
    route: Route,
  },
];

export const pagesRoute = [
  {
    id: 900,
    path: routes.noaccess,
    name: 'noaccess',
    element: <NoAccess />,
    route: Route,
  },
  {
    id: 0,
    path: routes.authcallback,
    name: 'authcallback',
    element: <AuthCallback />,
    route: Route,
  },
  {
    id: 1,
    path: routes.signin,
    name: 'signin',
    element: <Signin />,
    route: Route,
  },
  {
    id: 2,
    path: routes.signintwo,
    name: 'signintwo',
    element: <SigninTwo />,
    route: Route,
  },
  {
    id: 3,
    path: routes.signinthree,
    name: 'signinthree',
    element: <SigninThree />,
    route: Route,
  },
  {
    id: 4,
    path: routes.register,
    name: 'register',
    element: <Register />,
    route: Route,
  },
  {
    id: 5,
    path: routes.registerTwo,
    name: 'registerTwo',
    element: <RegisterTwo />,
    route: Route,
  },
  {
    id: 6,
    path: routes.registerThree,
    name: 'registerThree',
    element: <RegisterThree />,
    route: Route,
  },
  {
    id: 7,
    path: routes.forgotPassword,
    name: 'forgotPassword',
    element: <Forgotpassword />,
    route: Route,
  },
  {
    id: 7,
    path: routes.forgotPasswordTwo,
    name: 'forgotPasswordTwo',
    element: <ForgotpasswordTwo />,
    route: Route,
  },
  {
    id: 8,
    path: routes.forgotPasswordThree,
    name: 'forgotPasswordThree',
    element: <ForgotpasswordThree />,
    route: Route,
  },
  {
    id: 9,
    path: routes.resetpassword,
    name: 'resetpassword',
    element: <Resetpassword />,
    route: Route,
  },
  {
    id: 10,
    path: routes.resetpasswordTwo,
    name: 'resetpasswordTwo',
    element: <ResetpasswordTwo />,
    route: Route,
  },
  {
    id: 11,
    path: routes.resetpasswordThree,
    name: 'resetpasswordThree',
    element: <ResetpasswordThree />,
    route: Route,
  },
  {
    id: 12,
    path: routes.emailverification,
    name: 'emailverification',
    element: <EmailVerification />,
    route: Route,
  },
  {
    id: 12,
    path: routes.emailverificationTwo,
    name: 'emailverificationTwo',
    element: <EmailverificationTwo />,
    route: Route,
  },
  {
    id: 13,
    path: routes.emailverificationThree,
    name: 'emailverificationThree',
    element: <EmailverificationThree />,
    route: Route,
  },
  {
    id: 14,
    path: routes.twostepverification,
    name: 'twostepverification',
    element: <Twostepverification />,
    route: Route,
  },
  {
    id: 15,
    path: routes.twostepverificationTwo,
    name: 'twostepverificationTwo',
    element: <TwostepverificationTwo />,
    route: Route,
  },
  {
    id: 16,
    path: routes.twostepverificationThree,
    name: 'twostepverificationThree',
    element: <TwostepverificationThree />,
    route: Route,
  },
  {
    id: 17,
    path: routes.lockscreen,
    name: 'lockscreen',
    element: <Lockscreen />,
    route: Route,
  },
  {
    id: 18,
    path: routes.error404,
    name: 'error404',
    element: <Error404 />,
    route: Route,
  },
  {
    id: 19,
    path: routes.error500,
    name: 'error500',
    element: <Error500 />,
    route: Route,
  },
  {
    id: 20,
    path: routes.comingsoon,
    name: 'comingsoon',
    element: <Comingsoon />,
    route: Route,
  },
  {
    id: 21,
    path: routes.undermaintenance,
    name: 'undermaintenance',
    element: <Undermaintainence />,
    route: Route,
  },
];
